import { ItemMonitoramento, SituacaoMonitoramento } from './item-monitoramento.model';

export class ItemMonitoramentoDetalhado {

  public situacao: SituacaoMonitoramento;
  public erro: string;

  constructor(
    public nome: string,
    item: ItemMonitoramento) {
    this.situacao = item.situacao;
    this.erro = item.erro;
  }

  public isFalha(): boolean {
    return this.situacao === SituacaoMonitoramento.FALHA;
  }

  public getSituacaoDescricao(): string {
    switch (this.situacao) {
      case SituacaoMonitoramento.SUCESSO:
        return 'Sucesso';
      case SituacaoMonitoramento.FALHA:
        return 'Falha';
      case SituacaoMonitoramento.IGNORADO:
        return 'Ignorado';
    }
  }
}

